var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-visa-type"},_vm._l((_vm.countryInfo.visa_type_list),function(item){return _c('div',{key:item,staticClass:"visa-type-item",class:{ active: item === _vm.inner_visa_type },on:{"click":function($event){return _vm.changeVisaType(item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }